import { FilterType } from '../../../../../shared/enums/filter-type.enum'
import { ResourceSlug } from '../../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { Filter } from '../../../../../shared/interfaces/filter.interface'

export const useCaseFilterGroups: {
  name?: string
  filters: Filter[]
  isHidden?: boolean
}[] = [
  {
    filters: [
      {
        title: 'Search',
        filterType: FilterType.TextInput,
        queryParam: 'terms',
        helpText: 'Search use cases by name...',
        isOpen: true
      }
    ]
  },
  {
    name: 'Filters',
    filters: [
      {
        title: 'Related tool',
        filterType: FilterType.SelectAutocomplete,
        queryParam: 'toolIds',
        helpText: 'Search the related tool by its name...',
        isOpen: true
      },
      {
        title: 'Objective covered',
        slug: ResourceSlug.Objectives,
        filterType: FilterType.MultiTags,
        queryParam: 'objectiveIds',
        relativeResourceObjectKey: 'objectives',
        helpText:
          'Tool helps to ensure that AI applications are or help achieve the following objective:',
        isOpen: true
      },
      {
        title: 'Target sector(s)',
        slug: ResourceSlug.TargetSectors,
        filterType: FilterType.MultiTags,
        queryParam: 'targetSectorIds',
        relativeResourceObjectKey: 'targetSectors',
        helpText: 'Policy area(s) where the tool is expected to be implemented'
      },
      {
        title: 'Target audience',
        slug: ResourceSlug.TargetUsers,
        filterType: FilterType.CheckBox,
        queryParam: 'targetUserIds',
        relativeResourceObjectKey: 'targetUsers',
        helpText: 'Expected users of the tool'
      },
      {
        title: 'Impacted stakeholders',
        slug: ResourceSlug.ImpactedStakeholder,
        filterType: FilterType.CheckBox,
        queryParam: 'impactedStakeholderIds',
        relativeResourceObjectKey: 'impactedStakeholders',
        helpText:
          'Groups of people that will be impacted by the use of the tool'
      },
      {
        title: 'Purpose or action of the AI system',
        slug: ResourceSlug.Purposes,
        filterType: FilterType.CheckBox,
        queryParam: 'purposeIds',
        relativeResourceObjectKey: 'purposes',
        helpText:
          'Tasks performed by the AI application for which the tool is relevant'
      },
      {
        title: 'Organisation',
        slug: ResourceSlug.Organisations,
        filterType: FilterType.MultiTags,
        queryParam: 'organisationIds',
        relativeResourceObjectKey: 'organisations',
        helpText: 'The organisation that developed the tool',
        isOpen: true
      }
    ]
  }
]
